"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.byMatching = byMatching;
exports.getWidgetValue = getWidgetValue;
exports.getWidgetValues = getWidgetValues;
exports.isTextAreaWidget = isTextAreaWidget;
exports.getPrimaryMediaWidget = getPrimaryMediaWidget;
exports.getPrimaryMediaWidgetId = getPrimaryMediaWidgetId;
exports.getBodyWidgets = getBodyWidgets;
exports.getMediaWidgets = getMediaWidgets;
exports.makeWidget = makeWidget;
exports.spreadWidget = spreadWidget;

var _mediaTypes = require("../mediaTypes");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function widgetMatches(widget, tests) {
  var matches = true;

  if (tests.hasOwnProperty("type")) {
    matches = matches && widget.widget_type == tests.type;
  }

  if (tests.hasOwnProperty("key")) {
    if (tests.hasOwnProperty("value")) {
      matches = matches && widget.keys.some(function (k) {
        return k.key == tests.key && "" + k.value == "" + tests.value;
      });
    } else {
      matches = matches && widget.keys.some(function (k) {
        return k.key == tests.key;
      });
    }
  }

  return matches;
}

function byValue(key) {
  var cast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
    return i;
  };

  return function () {
    for (var _len = arguments.length, widgets = Array(_len), _key = 0; _key < _len; _key++) {
      widgets[_key] = arguments[_key];
    }

    var _widgets$map = widgets.map(function (w) {
      return cast(getWidgetValue(w, key));
    }),
        _widgets$map2 = _slicedToArray(_widgets$map, 2),
        a = _widgets$map2[0],
        b = _widgets$map2[1];

    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }

    return 0;
  };
}

function byMatching() {
  for (var _len2 = arguments.length, tests = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    tests[_key2] = arguments[_key2];
  }

  return function (widget) {
    return widget && tests.reduce(function (matches, test) {
      return matches || widgetMatches(widget, test);
    }, false);
  };
}

function getWidgetValue(widget, key) {
  var _widget$keys$filter = widget.keys.filter(function (k) {
    return k.key == key;
  }),
      _widget$keys$filter2 = _slicedToArray(_widget$keys$filter, 1),
      _widget$keys$filter2$ = _widget$keys$filter2[0];

  _widget$keys$filter2$ = _widget$keys$filter2$ === undefined ? {} : _widget$keys$filter2$;
  var value = _widget$keys$filter2$.value;

  return value;
}

function getWidgetValues(widget, keys) {
  return widget.keys.reduce(function (o, _ref) {
    var key = _ref.key,
        value = _ref.value;
    return keys.includes(key) ? _extends({}, o, _defineProperty({}, key, value)) : o;
  }, {});
}

function isTextAreaWidget(widget) {
  return widgetMatches(widget, { type: "TextArea" });
}

function getPrimaryMediaWidget(widgets) {
  var _widgets$filter = widgets.filter(byMatching({ key: "primary", value: true })),
      _widgets$filter2 = _slicedToArray(_widgets$filter, 1),
      primaryImage = _widgets$filter2[0];

  return primaryImage;
}

function getPrimaryMediaWidgetId(widgets) {
  var primaryImageWidget = getPrimaryMediaWidget(widgets);

  if (primaryImageWidget) {
    return getWidgetValue(primaryImageWidget, "media_id");
  }
}

function getBodyWidgets(widgets) {
  // two filter tests to catch legacy content
  return widgets.filter(byMatching({ type: "TextArea" }, /* or */{ key: "body", value: "true" })).sort(byValue("order", parseInt));
}

function getMediaWidgets(widgets) {
  // two tests to catch legacy content
  return widgets.filter(byMatching({ type: _mediaTypes.VIDEO }, { type: _mediaTypes.IMAGE }, /* or */{ key: "media", value: "true" }));
}

function makeWidget(type, properties) {
  // only those properties that have defined values
  function _hasValue(list, key) {
    var val = properties[key];
    if (val !== undefined) {
      return [].concat(_toConsumableArray(list), [{ key: key, value: "" + val }]);
    } else {
      return list;
    }
  }

  return {
    widget_type: type,
    keys: Object.keys(properties).reduce(_hasValue, [])
  };
}

function spreadWidget(widget) {
  if (!widget) {
    return {};
  }

  return (widget.keys || []).reduce(function (accumulator, _ref2) {
    var key = _ref2.key,
        value = _ref2.value;

    return _extends({}, accumulator, _defineProperty({}, key, value));
  }, { widget_type: widget.widget_type });
}


//////////////////
// WEBPACK FOOTER
// ../~/sportinglife-react-common/lib/widgets/index.js
// module id = 1634
// module chunks = 0